import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=4655ee59&scoped=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeader.vue?vue&type=style&index=0&id=4655ee59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655ee59",
  null
  
)

export default component.exports